<template>
  <onboarding-step>
    <template #heading>
      Great! Let's recap.
    </template>
    <template #content>
      <div class="sm:text-lg flex flex-col gap-3">
        <div class="grid gap-2">
          <div>
            <span class="font-medium text-blue dark:text-white">
              High interest
            </span>
            <l-button
              class="px-2 font-medium text-base text-orange-600 hover:text-orange-700"
              @click="$emit('back', ReportStepJobs)"
            >
              <icon name="edit"/>
              <span class="sr-only">Edit answers</span>
            </l-button>
          </div>
          <ul class="mb-0 pl-4 list-none">
            <li v-for="job in high" :key="job.field" class="flex items-center gap-2">
              <icon name="squareCheck" set="solid" color="green"/>
              {{ job.title }}
            </li>
            <li v-if="user.report.national" class="flex items-center gap-2">
              <icon name="squareCheck" set="solid" color="green"/>
              High-prestige job
            </li>
            <li v-else-if="!high.length">
              None
            </li>
          </ul>
        </div>

        <div class="grid gap-2">
          <div>
            <span class="font-medium text-blue dark:text-white">
              Medium interest
            </span>
            <l-button
              class="px-2 font-medium text-base text-orange-600 hover:text-orange-700"
              @click="$emit('back', ReportStepJobs)"
            >
              <icon name="edit"/>
              <span class="sr-only">Edit answers</span>
            </l-button>
          </div>
          <ul class="mb-0 pl-4 list-none">
            <li v-for="job in medium" :key="job.field" class="flex items-center gap-2">
              <icon name="squareCheck" color="green"/>
              {{ job.title }}
            </li>
            <li v-if="!medium.length">
              None
            </li>
          </ul>
        </div>

        <div class="grid gap-2">
          <div>
            <span class="font-medium text-blue dark:text-white">
              Low interest
            </span>
            <l-button
              class="px-2 font-medium text-base text-orange-600 hover:text-orange-700"
              @click="$emit('back', ReportStepJobs)"
            >
              <icon name="edit"/>
              <span class="sr-only">Edit answers</span>
            </l-button>
          </div>
          <ul class="mb-0 pl-4 list-none">
            <li v-for="job in low" :key="job.field" class="flex items-center gap-2">
              <icon name="squareCheck" color="green"/>
              {{ job.title }}
            </li>
            <li v-if="!low.length">
              None
            </li>
          </ul>
        </div>

        <div v-if="none.length" class="flex flex-col gap-2">
          <div>
            <span class="font-medium text-blue dark:text-white">
              No interest
            </span>
            <l-button
              class="px-2 font-medium text-base text-orange-600 hover:text-orange-700"
              @click="$emit('back', ReportStepJobs)"
            >
              <icon name="edit"/>
              <span class="sr-only">Edit answers</span>
            </l-button>
          </div>
          <ul class="mb-0 pl-4 list-none">
            <li v-for="job in none" :key="job.field" class="flex items-center gap-2">
              <icon name="squareX" color="red"/>
              {{ job.title }}
            </li>
          </ul>
        </div>
      </div>
    </template>
    <template #footer>
      <podcast-promo class="lg:hidden"/>
    </template>
    <template #subcontent>
      <div class="flex flex-col gap-10">
        <img src="/images/illustration-sitting-4.svg" class="h-auto mx-auto">
        <podcast-promo/>
      </div>
    </template>
  </onboarding-step>
</template>

<script setup>
import Icon from "@/components/Icon.vue"
import LButton from "@/components/buttons/LButton.vue"
import OnboardingStep from "@/components/onboardings/OnboardingStep.vue"
import PodcastPromo from "@/components/PodcastPromo.vue"
import ReportStepJobs from "@/components/onboardings/ReportStepJobs.vue"
import { Priority } from "@/models/Priority"
import { computed } from "vue"
import { useJobs } from "@/composables/useJobs"

const user = defineModel({ type: Object, required: true })

defineEmits(["back"])

const { jobs } = useJobs()

const high = computed(() => {
  return jobs.filter((option) => user.value.report[option.field] === Priority.HIGH)
})
const medium = computed(() => {
  return jobs.filter((option) => user.value.report[option.field] === Priority.MEDIUM)
})
const low = computed(() => {
  return jobs.filter((option) => user.value.report[option.field] === Priority.LOW)
})
const none = computed(() => {
  return jobs.filter((option) => user.value.report[option.field] === Priority.NO)
})
</script>
